export const APOLLO_CLIENT_NAMES = {
  audit: 'audit',
  finding: 'finding',
  certificate: 'certificate',
  schedule: 'schedule',
  invoice: 'invoice',
  contact: 'contact',
  notification: 'notification',
} as const;
